import { render, staticRenderFns } from "./Subscribe1.vue?vue&type=template&id=8da4d1d0&scoped=true"
import script from "./Subscribe1.vue?vue&type=script&lang=js"
export * from "./Subscribe1.vue?vue&type=script&lang=js"
import style0 from "./Subscribe1.vue?vue&type=style&index=0&id=8da4d1d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da4d1d0",
  null
  
)

export default component.exports